/// <reference path='../../interfaces/interfaces.d.ts' />

import functions = require('../../global/functions');

interface IOrgScope extends ng.IScope {
    orgName: string;
}

'use strict';

class TopbarController {
    public static $inject = [
        '$rootScope',
        '$state',
        'User',
        'Orgs'
    ];

    public user;

    constructor(private $scope: IOrgScope,
                private $state: ng.ui.IStateService,
                private User: IUserService,
                private Orgs: IOrgsService) {
        this.user = User.getCurrentUser();
        if (this.User.getCurrentUser().userData.user.is_superuser) {
            $scope.orgName = '';
        } else {
            Orgs.getOrgFromCache(org => {
                $scope.orgName = org.name;
            });
        }
    }
}

angular.module('beneple.global')
    .controller('TopbarController', TopbarController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/topbar.controller.ts